import React from 'react';
import { Steps } from 'antd';
import './index.css';
interface ProgressStepsProps {
    stepsObject: Array<any>
}
const ProgressSteps: React.FC<ProgressStepsProps> = ({stepsObject}: ProgressStepsProps) => {
    const { Step } = Steps;
    return (
        <Steps progressDot  direction="vertical" >
            {
              stepsObject && stepsObject.map((step:any,index:number)=>
              <Step key={index} title={step.title} description={step.description} />)  
            }
        </Steps>
    )
};


export default ProgressSteps;